const ShoppingCart = require('od-modules/cart/cart');

const FLEXUK164 = 'FLEXUK164';
const FLEXRB160 = 'FLEXRB160';
const FLEXRB156 = 'FLEXRB156';
const FLEX_AX04 = 'FLEX_AX04';
const UKFLEX_AX11 = 'UKFLEX_AX11';
const CNXFLT151 = 'CNXFLT151';
const CNXFHL157 = 'CNXFHL157';
const CANX_AX01 = 'CANX_AX01';
const UKCANX_AX10 = 'UKCANX_AX10';
const CNX_1_26_5251592 = '1-26-5251592';

const FILTERING_RULES = {
    FLEXIBLE_FARE_RULE: [
        FLEXUK164,
        FLEXRB160,
        FLEXRB156,
        FLEX_AX04,
        UKFLEX_AX11,
    ],
    PREMIUM_FARE_RULE: [
        FLEXUK164,
        FLEXRB160,
        FLEXRB156,
        FLEX_AX04,
        UKFLEX_AX11,
        CNXFLT151,
        CNXFHL157,
        CANX_AX01,
        UKCANX_AX10,
        CNX_1_26_5251592,
    ],
};

const getPolicies = (products = []) => products.map(({type}) => type);

const getSelectedProducts = () => [
    ...getPolicies(ShoppingCart.take.insurances()),
    ...getPolicies(ShoppingCart.take.serviceOptions()),
    ...getPolicies(ShoppingCart.take.fareRules()),
];

const getProductsToFilter = () => getSelectedProducts().reduce((result, type) => [
    ...result,
    ...(FILTERING_RULES[type] || []),
], []);

const isProductFiltered = (policy) => Odigeo.AB.isFareRulesProductHiding && getProductsToFilter().includes(policy);

module.exports = isProductFiltered;
